import React from "react";

import AsyncSelect from "./AsyncSelect";

function SelectProduto(props) {
  return <AsyncSelect {...props} />;
}

export default SelectProduto;
